import { RecipeFavoriteQuery } from '@diamond/shared/types';
import {
  infiniteQueryOptions,
  queryOptions,
  useInfiniteQuery,
  useQuery,
} from '@tanstack/react-query';

import { getRecipeFavorite, getRecipeFavoriteTag } from '../queries/recipe';
import { useAuthStore } from '../stores';
import { RECIPE_QUERY_KEY } from './useGetRecipeList';

type InfiniteRecipeFavoriteQuery = Omit<Partial<RecipeFavoriteQuery>, 'page'>;

function infiniteRecipeFavoriteQueryOptions(
  token: string | null,
  params?: InfiniteRecipeFavoriteQuery
) {
  return infiniteQueryOptions({
    queryKey: [RECIPE_QUERY_KEY, 'favorite', params],
    queryFn: ({ pageParam }) =>
      getRecipeFavorite(token, {
        page: pageParam,
        size: params?.size || 12,
        ...params,
      }),
    initialPageParam: 1,
    getNextPageParam: ({ nextPage }) => nextPage,
  });
}

export function useGetInfiniteRecipeFavorite(
  params?: InfiniteRecipeFavoriteQuery
) {
  const token = useAuthStore((s) => s.access_token);
  return useInfiniteQuery(infiniteRecipeFavoriteQueryOptions(token, params));
}

function recipeFavoriteTagQueryOptions(token: string | null) {
  return queryOptions({
    queryKey: [RECIPE_QUERY_KEY, 'favorite', 'tag'],
    queryFn: () => getRecipeFavoriteTag(token),
  });
}

export function useGetRecipeFavoriteTag() {
  const token = useAuthStore((s) => s.access_token);
  return useQuery(recipeFavoriteTagQueryOptions(token));
}
